import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import routes from './routes'
import store from '../state/store'
import { menuItems } from "../components/menu";

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})


router.beforeEach((to, from, next) => {
 
  let link = to.name;  
    if(link == "default" || link == "login" || link == "logout"){  
      next()  
    }else{
      if(store.getters["auth/isAuth"]){  
      let roller= store.getters["auth/UserRolles"] 
      let YetkiSorgu = []
      let SayfaRolleri = []  

            for(let i=0; i<menuItems.length; i++){
              var submenu = menuItems[i].subItems

              if(submenu.length != 0){
                for(let j=0; j<submenu.length;j++){
                  YetkiSorgu= submenu.filter(notification => notification.link.includes(link)); 
               
                  if(YetkiSorgu.length !=0){
                    SayfaRolleri = YetkiSorgu[0].role
                  }
                } 
              }else{
                YetkiSorgu= menuItems.filter(notification => notification.link.includes(link));
                if(YetkiSorgu.length !=0){
                  SayfaRolleri = YetkiSorgu[0].role
                } 
              }

            }       
           
            let kontrol = false
            for(let a=0;  a<SayfaRolleri.length; a++){
                  if(SayfaRolleri[a] != "*"){
                    let YetkiSorgu = roller.filter(function(Role) {
                            return Role == SayfaRolleri[a];
                    });   
                    if(YetkiSorgu.length != 0) kontrol = true 
                  }else{
                    kontrol = true 
                  }
            }  
            if(kontrol) next() 
            else router.push("/");
        }else{ 
          router.push("/");
        }    
    } 
      
   
 });


export default router
